import { Gift, theme } from "ui";
import { MouseEventHandler } from "react";
import { ContainerButton, DescriptionButton } from "./styles";

interface ButtonAddProductToWeddingListProps {
  borderLine?: boolean;
  fontSize?: string;
  textVisibleMobile?: boolean;
  scaleMedia?: number;
  actionAddToGift: MouseEventHandler<HTMLButtonElement> | undefined;
  isBlackTheme?: boolean;
}

const ButtonAddProductToWeddingList = ({
  borderLine,
  textVisibleMobile,
  fontSize,
  scaleMedia,
  isBlackTheme,
  actionAddToGift,
}: ButtonAddProductToWeddingListProps) => {
  return (
    <ContainerButton
      isBlackTheme={isBlackTheme}
      borderLine={borderLine}
      fontSize={fontSize}
      scaleMedia={scaleMedia}
      onClick={actionAddToGift}
    >
      <Gift
        color={
          isBlackTheme
            ? theme.colors.blackFriday.white
            : theme.colors.primary["200"]
        }
        height={26}
      />
      <DescriptionButton textVisibleMobile={textVisibleMobile}>
        Adicionar à minha lista
      </DescriptionButton>
    </ContainerButton>
  );
};

export default ButtonAddProductToWeddingList;
